import Image from 'next/image';
import Link from 'next/link';
import { Card, CardContent } from '@/components/ui/card';
import { components } from '@/types/strapi';

export function CaseStudyCard({
	title,
	slug,
	image,
}: components['schemas']['CaseStudy']) {
	return (
		<Card className="group h-full overflow-hidden rounded-lg border-0 bg-white">
			<CardContent className="flex h-full flex-col p-0">
				<Link
					href={'/case-study/' + slug}
					className="relative block overflow-hidden"
					aria-label={title || 'Case study link'}>
					<div className="relative aspect-video overflow-hidden">
						<Image
							src={image?.url || '/placeholder.svg'}
							alt={image?.alternativeText || 'Case study image'}
							width={740}
							height={400}
							className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
							loading="lazy"
							decoding="async"
						/>
						<div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
					</div>
				</Link>
				<div className="flex flex-grow flex-col p-6">
					<h3 className="mb-4 line-clamp-2 text-xl font-bold">
						<Link
							href={'/case-study/' + slug}
							className="transition-colors hover:text-blue-600">
							{title}
						</Link>
					</h3>
					<Link
						href={`/case-study/${slug}`}
						className="inline-flex h-12 w-full items-center justify-center rounded-md border border-blue-600 bg-blue-600 px-6 text-base font-medium text-white transition-all duration-300 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
						Download Case Study
					</Link>
				</div>
			</CardContent>
		</Card>
	);
}
